import React, { FC } from 'react';

import { ChannelProvider, useChannel } from 'ably/react';

import { User, WebSocketEvent } from 'models';
import { AblyHelpers } from 'helpers/AblyHelpers';

import { IntercomService } from 'services/IntercomService';
import { NotificationService } from 'services/NotificationService';

const Listeners: FC<{ userId: string }> = ({ userId }) => {
    const { channelError, connectionError } = useChannel(userId, async (message) => {
        switch (message.name) {
            case WebSocketEvent.USER_REFRESH_NOTIFICATIONS: {
                const { notificationId, readAt } = message.data ?? {};

                if (notificationId) {
                    await NotificationService.markReadLocally(notificationId, readAt ?? new Date().toISOString());
                } else {
                    await NotificationService.refreshInbox();
                }

                break;
            }
            case WebSocketEvent.USER_RECEIVE_NOTIFICATION: {
                NotificationService.receiveNotification(message.data.notification);
                break;
            }
            case WebSocketEvent.INTERCOM_REFRESH_COMPONENT_CHANNELS: {
                await IntercomService.refreshComponentChannels(message.data.componentId);
                break;
            }
            case WebSocketEvent.INTERCOM_REFRESH_COMPANY_CHANNELS: {
                await IntercomService.refreshCompanyChannels(message.data.companyId);
                break;
            }
            case WebSocketEvent.INTERCOM_REFRESH_PROJECT_CHANNELS: {
                await IntercomService.refreshProjectChannels(message.data.projectId);
                break;
            }
            case WebSocketEvent.INTERCOM_REFRESH_CHANNEL_MESSAGES: {
                await IntercomService.refreshChannelMessages(message.data.channelId);
                break;
            }
        }
    });

    AblyHelpers.log('User', channelError, connectionError);

    return null;
};

const RealtimeUserProvider: FC<{ user: User; children: React.ReactNode }> = ({ user, children }) => (
    <ChannelProvider channelName={user.id}>
        <Listeners userId={user.id} />
        {children}
    </ChannelProvider>
);

export { RealtimeUserProvider };
